"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmptySection = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        minHeight: 213,
        position: 'relative',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            minHeight: 281
        }
    };
});
const Content = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignContent: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        left: 0,
        padding: theme.spacing(3, 6),
        position: 'absolute',
        textAlign: 'center',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%'
    };
});
const EmptySection = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { isEmptyBasket } = (0, _contexts.useBasketContext)();
    if (!isEmptyBasket) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        "data-testid": getTestId('empty-basket'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Content, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    gutterBottom: true,
                    color: "palette.grey[700]",
                    variant: "h4",
                    component: "div",
                    children: formatMessage('emptyBag')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
                    gutterBottom: true,
                    color: "palette.grey[500]",
                    children: [
                        "- ",
                        formatMessage('lookingPrettyEmptyInYourBag'),
                        " -"
                    ]
                })
            ]
        })
    });
};
exports.EmptySection = EmptySection;
